import { section } from '@/neon';
import isMobile from 'is-mobile';
import { listen } from '@fluorescent/dom';

const ei = {
  get: () => JSON.parse(localStorage.getItem('exitIntent')),
  set: val => localStorage.setItem('exitIntent', val),
};

section('exit-intent', {
  onLoad() {
    this.closeBtn = this.container.querySelector('[data-close-icon]');
    const mobileTimeout = parseInt(this.container.dataset.mobileLandingTimeout);

    const mouseLeave = e => {
      if (!e.relatedTarget && !e.toElement) {
        this.showPopup();
        document.body.removeEventListener('mouseout', mouseLeave);
      }
    };

    const close = e => {
      this.hidePopup();
      ei.set(true);
    };

    this.handleKeyboard = e => {
      if (this.container.classList.contains('visible') && (e.key == 'Escape' || e.keyCode === 27)) {
        close();
      }
    };

    if (!ei.get()) {
      if (isMobile()) {
        setTimeout(() => {
          this.showPopup();
        }, mobileTimeout);
      } else {
        document.body.addEventListener('mouseout', mouseLeave);
      }
      this.closeBtn.addEventListener('click', close);
      window.addEventListener('keyup', this.handleKeyboard);
    }
  },

  showPopup() {
    this.container.classList.add('animating');
    setTimeout(() => {
      this.container.classList.add('visible');
    }, 250);
  },

  removeListeners() {
    this.closeBtn.removeEventListener('click', close);
    window.removeEventListener('keyup', this.handleKeyboard);
  },

  hidePopup() {
    this.container.classList.remove('visible');
    this.container.classList.add('hidden');
    setTimeout(() => {
      this.container.classList.remove('animating');
    }, 250);
    this.removeListeners();
  },

  onSelect() {
    this.showPopup();
  },

  onDeselect() {
    this.hidePopup();
  },

  onUnload() {
    this.removeListeners();
  },
});
